import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, Accordion, DatePicker, Redirect
} 
from '../../noser-hris-component';
import da from "../../noser-dataaccess"
class Employees extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,
            openModal       :   false,
            disableBtn      :   true,

            employeeId      :   "",
            dateHired       :   "",
            employmentId    :   "",
            positionId      :   "",

            positionDDL     :   [],
            employmentDDL   :   [],
            employeeDDL     :   [],
            employeeGRID    :   []
        }
    }
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.getData()
    }
    async getData(){
        this.setState({isloading:true})
        
        //GET POSITIONS
        let result = await da.post({
            uri:"Maintenance/GetPositions",
            params:{
                "IpAddress"     :   "0.0.0.0",
                "ClientId"      :   this.state.userinfo.clientId,
                "UserId"        :   this.state.userinfo.userId
            }
        }, cb => {
            if(cb.status==="0"){
                this.setState({...this.state=cb,isshow:false})
            }else{
                this.setState({...this.state=cb,positionDDL:cb.data.positions,isshow:false,isloading:true})
            }
        })

        //GET EMPLOYMENT TYPES
        await da.post({
            uri:"Maintenance/GetEmployeeStatusTypes",
            params:{
                "IpAddress"     :   "0.0.0.0",
                "ClientId"      :   this.state.userinfo.clientId,
                "UserId"        :   this.state.userinfo.userId
            }
        }, cb =>{
            if(cb.status==="0"){
                this.setState({...this.state=cb,isshow:false})
            }else{
                this.setState({...this.state=cb,employmentDDL:cb.data.statusTypes,isshow:false})
            }
        })

        //GET EMPLOYEES
        await da.post({
            uri:"Manning/GetEmploymentList",
            params:{
                "IpAddress"     :   "0.0.0.0",
                "ClientId"      :   this.state.userinfo.clientId,
                "UserId"        :   this.state.userinfo.userId,
                "EmployeeId"    :   this.state.employeeId,
                "PositionId"    :   this.state.positionId,
                "EmploymentStatusId":this.state.employmentId,
                "DateHired"     :   this.state.dateHired==="" ? "" : moment(this.state.dateHired).format("MM/DD/YYYY")
            }
        }, cb =>{
            if(cb.status==="0"){
                this.setState({...this.state=cb,isshow:false})
            }
            else{
                this.setState({...this.state=cb,employeeDDL:cb.data.employees,employeeGRID:cb.data.employees,isshow:false})
            }
        })


    }
    handleChangedDDL = name => e =>{
        this.setState({isshow:false,message:""})
        if(e.length===0) {this.setState({[name]:"",isshow:false,message:""});return}
        this.setState({[name]:e[0].id})
        console.log(name + " " + e[0].id)
    }
    handleChangedDate = name => date =>{
        console.log(date)
        if(date===null){
            this.setState({[name]:""})
        }else{
            this.setState({[name]:date})
        }
        
    }
    handleSearch = async() => {
        this.setState({isloading:true,alerttype:'',isshow:false,color:'',message:'',fade:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "EmployeeId"    :   this.state.employeeId,
            "PositionId"    :   this.state.positionId,
            "EmploymentStatusId":this.state.employmentId,
            "DateHired"     :   this.state.dateHired==="" ? "" : moment(this.state.dateHired).format("MM/DD/YYYY")
        }
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Manning/GetEmploymentList",  params)
        .then(res => {
            const data = res.data;
            console.log(data)
            this.setState({ employeeGRID:data.employees,isloading:false});

            if(data.status==="0"){
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   data.message,
                    fade        :   true
                })
            }
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
    }
    handleEdit = async(row) =>{
        sessionStorage.setItem("editamanning_" + this.state.userinfo.userId + this.state.userinfo.employeeId, JSON.stringify(row))
        this.setState({navigate:true})
    }
    GridDataModified(oldValue, newValue, id, column) {
        this.setState({disableBtn:true})
        this.state.employeeGRID.forEach(item => {
            if (item.id === id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                this.setState({disableBtn:false})
            }
        })
    }
    render() {
        const {navigate} = this.state;
        if (navigate) {
            return <Redirect to="/manageemployee" push={true} />;
        } 
        const col = [
            {
                dataField   : 'employeeNo',
                text        : 'EMPLOYEE NO',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'9%' }},
                style:{textAlign:'center',width:'9%'},
            },
            {
                dataField   : 'employeeName',
                text        : 'EMPLOYEE NAME',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'30%' }},
                style:{textAlign:'left',width:'30%'},
                formatter   :   (cell, row, isSelect) => {
                    return (
                        <Button 
                            onClick={e => this.handleEdit(row)}
                            style={{height:'18px',paddingTop:'0',marginTop:'-4px',fontSize:'11px'}} 
                            variant="link"
                    >row.employeeName</Button>
                    );
                },
            },
            {
                dataField   : 'position',
                text        : 'POSITION',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'20%' }},
                style:{textAlign:'left',width:'20%'}
            },
            {
                dataField   : 'employmentStatus',
                text        : 'EMPLOYMENT STATUS',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%' }},
                style:{textAlign:'left',width:'10%'}
            },
            {
                dataField   : 'dateHired',
                text        : 'DATE HIRED',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%' }},
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField   : 'contractDateStart',
                text        : 'CONTRACT DATE START',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'11%' }},
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField   : 'contractDateStart',
                text        : 'CONTRACT DATE END',
                editable:true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%' }},
                style:{textAlign:'center',width:'10%'}
            },
        ]

    const selectRow = {
        mode: 'checkbox',
        clickToSelectAndEditCell: true,
        hideSelectAll: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            this.setState({disableBtn:true})
            this.state.employeeGRID.forEach(item=>{
                if(item.id===row.id)
                {
                    item.isDeleted = isSelect ? "1" : "0"
                    item.isModified = isSelect ? "1" : "0"
                }
                if(item.isDeleted==="1"){
                    this.setState({disableBtn:false})
                }
            })
        }
    }
    const rowEvents = {onClick: (e, row, rowIndex) => {}}
    return(
            <div>
                <Banner />
                <Container className="themed-container" fluid={true}>
                    <Card className="mt-1">
                        <Card.Header className='login-card'>Manage Employees</Card.Header>
                        <Card.Body>
                            <div>
                                <Form>
                                    <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                        <div className={this.state.color}></div> 
                                        {this.state.message}
                                    </Alert>
                                    <Accordion defaultActiveKey="1">
                                        <div className="card-header-tab">
                                            <Accordion.Toggle as={Button} variant="link" eventKey="1" style={{color: "#FFFFFF"}}>
                                                SEARCH FILTER (COLLAPSE)
                                            </Accordion.Toggle>
                                        </div>
                                        <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                                <Form>
                                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                                            EMPLOYEE NAME
                                                        </Form.Label>
                                                        <Col sm={4}>
                                                            <Typeahead
                                                                labelKey='employeeName'
                                                                id="basic-example"
                                                                name='employeeId'
                                                                onChange={this.handleChangedDDL("employeeId")}
                                                                options={this.state.employeeDDL}
                                                                placeholder="Select Employee"
                                                            />
                                                        </Col>
                                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                                            POSITION
                                                        </Form.Label>
                                                        <Col sm={4}>
                                                            <Typeahead
                                                                labelKey='name'
                                                                id="basic-example"
                                                                name='positionId'
                                                                onChange={this.handleChangedDDL("positionId")}
                                                                options={this.state.positionDDL}
                                                                placeholder="Select Position"
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                                            EMPLOYMENT STATUS
                                                        </Form.Label>
                                                        <Col sm={4}>
                                                            <Typeahead
                                                                labelKey='name'
                                                                id="basic-example"
                                                                name='employmentId'
                                                                onChange={this.handleChangedDDL("employmentId")}
                                                                options={this.state.employmentDDL}
                                                                placeholder="Select Employment Status"
                                                            />
                                                        </Col>
                                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                                            DATE HIRED
                                                        </Form.Label>
                                                        <Col sm={4}>
                                                            <DatePicker
                                                                sm={4}
                                                                id="dateHired"
                                                                name="dateHired"
                                                                value={this.state.dateHired}
                                                                selected={this.state.dateHired}
                                                                onChange={this.handleChangedDate("dateHired")}
                                                                dateFormat={"MM/dd/yyyy"}
                                                                className="form-control"
                                                                autoComplete="off"
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                    <ButtonToolbar sm={12}>
                                                        <Button variant="primary" className="ml-auto noser-button" onClick={this.handleSearch}>SEARCH</Button>
                                                    </ButtonToolbar>
                                                </Form>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Accordion>
                                    <hr />
                                    <ButtonToolbar sm={12}>
                                        <NavLink to="/NewEmployee">
                                        <Button variant="primary" className="noser-button">Create New Employee</Button>
                                        </NavLink>
                                    </ButtonToolbar>
                                    <div className="mt-2">
                                        <Card.Header>List Of Employees</Card.Header>
                                        <BootstrapTable
                                            keyField = "id"
                                            data = { this.state.employeeGRID }
                                            columns = { col }
                                            pagination={ paginationFactory({sizePerPageRenderer}) }
                                            rowClasses="noser-table-row-class no-checkbox"
                                            striped
                                            hover
                                            condensed
                                            cellEdit = { cellEditFactory({
                                                mode: 'dbclick',
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                    this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                                    }
                                                })
                                            }
                                            rowEvents={ rowEvents }
                                            selectRow = { selectRow }
                                            noDataIndication={ () => <div>No record found.</div> }
                                        />
                                    </div>
                                </Form>
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
                
            </div> 
        )
    }

}

export default Employees 